import React, { useLayoutEffect, useRef, useState } from 'react'

import cx from '../../../utils/className'

import styles from './Tooltip.module.css'

const DIRECTION = {
  UP: styles.up,
  DOWN: styles.down,
  LEFT: styles.left,
  RIGHT: styles.right
}

const POINTER = {
  HAND: 'hand',
  ARROW: 'arrow',
  NONE: 'none'
}

const BODY_STYLE = {
  WHITE: styles.white,
  BLACK: styles.black,
  GRAY: styles.gray
}

const ARROW_HALF = 8
const ARROW_EDGE_PADDING = 4

export const computeAnchorArrowOffset = (anchorEl, tooltipEl) => {
  const anchorRect = anchorEl.getBoundingClientRect()
  const tooltipRect = tooltipEl.getBoundingClientRect()
  const anchorCenterX = anchorRect.left + anchorRect.width / 2
  const minOffset = ARROW_HALF + ARROW_EDGE_PADDING
  const maxOffset = tooltipRect.width - ARROW_HALF - ARROW_EDGE_PADDING

  return Math.min(
    Math.max(minOffset, anchorCenterX - tooltipRect.left),
    Math.max(minOffset, maxOffset)
  )
}

const Tooltip = props => {
  const direction = props.direction || DIRECTION.UP
  const tooltipRef = useRef(null)
  const [arrowOffset, setArrowOffset] = useState(null)
  const { anchorRef } = props

  useLayoutEffect(() => {
    if (
      !anchorRef?.current
      || !tooltipRef.current
      || props.pointer === POINTER.NONE
    ) {
      setArrowOffset(null)
      return
    }

    setArrowOffset(
      computeAnchorArrowOffset(anchorRef.current, tooltipRef.current)
    )
  }, [anchorRef, props.children, direction, props.pointer])

  let pointer
  const pointerClassName = cx(
    styles.rect,
    props.pointerClassName,
    anchorRef && styles.anchorPointer
  )

  if (props.pointer === POINTER.HAND) {
    pointer = (
      <div className={pointerClassName}>
        <div className={cx(styles.hand, direction)} />
      </div>
    )
  } else if (props.pointer === POINTER.NONE) {
    pointer = null
  } else {
    pointer = (
      <div className={pointerClassName}>
        <div className={cx(styles.triangle, direction)} />
      </div>
    )
  }

  const wrapperStyle = {
    ...props.style,
    ...(arrowOffset != null && { '--tooltip-arrow-offset': `${arrowOffset}px` }),
  }

  return (
    <div
      ref={tooltipRef}
      className={cx(styles.wrapper, props.className, direction, props.bodyStyle)}
      style={wrapperStyle}
    >
      <div className={cx(styles.content, props.contentClassName)}>
        {props.children}
      </div>
      {pointer}
    </div>
  )
}

Tooltip.DIRECTION = DIRECTION
Tooltip.POINTER = POINTER
Tooltip.BODY_STYLE = BODY_STYLE

export default Tooltip
